module.exports = __webpack_public_path__ + "img/trenholm-state.3a908362.jpg";